import { ReducerBuilder } from './reducerBuilder';
import { NotificationState } from 'acscp/store';
import { AddNotification, DismissNotification } from 'acscp/actions';

export const notificationReducer =
    new ReducerBuilder<NotificationState>([])
        .actionCase(AddNotification, (state, action) => {
            return [
                ...state.filter(n => n.cause !== action.cause),
                {
                    cause: action.cause,
                    message: action.message,
                    notificationType: action.notificationType,
                    messageValues: action.messageValues
                }
            ];
        })
        .actionCase(DismissNotification, (state, action) => {
            return state.filter(n => n.cause !== action.cause);
        })
        .build();
